import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from "../../common/Pagination";
import {
  getDepartmentList,
  DeleteDepartment,
  ChanegDepartmentstatus
} from "../../redux/services/DepartmentService/deparment.Services";

function DeparmentList() {
  const dispatch = useDispatch();

  const [rolesData, setRolesData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [totalDepartments, setTotalDepartments] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // GET LIST
  const fetchRoles = async (pageNo = 1,
    isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }
      const payload = {
        page: pageNo,
        per_page: limit,
      };
      const res = await getDepartmentList(payload);
      setRolesData(res?.data || []);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalDepartments(res?.total || 0);
    } catch (err) {
      console.log(err);
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchRoles();
  // }, []);
  useEffect(() => {
    fetchRoles(1, true);
  }, [limit]);
  // DELETE
  const handleDelete = async (id) => {
    try {
      await DeleteDepartment(id);
      fetchRoles();
    } catch (err) {
      console.log(err);
    }
  };
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchRoles(newPage, false);
    }
  };
  // STATUS TOGGLE
  const handleStatusToggle = async (id) => {
    try {
      await ChanegDepartmentstatus(id);
      fetchRoles();
    } catch (err) {
      console.log(err);
    }
  };

  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      {/* HEADER (UI SAME) */}
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>All Department List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Department List</span>
          </nav>
        </div>


        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="add-btn"
            onClick={() =>
              dispatch(
                openModal({
                  type: "add-department",
                  title: "Add Department",
                  data: null,
                  refreshData: fetchRoles,
                })
              )
            }
          >
            Add Department
          </button>
        </div>
      </div>
     <div className="main_page">
       {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

          {/* <div className="d-flex align-items-center gap-2">
    <label className="mb-0">Show</label>

    <select
      className="form-select form-select-sm"
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setPage(1);
      }}
    >
      <option value={10}>10</option>
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>
  </div> */}

          <div className="col-12 d-flex justify-content-end">
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>

        </div>
      )}
      <div className="st-wrapper-card text-center">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Change Status</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="5" className="text-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              ) : (


                rolesData.map((item, index) => (
                  <tr key={item.id}>
                      <td> {(page - 1) * limit + index + 1}</td>

                    <td style={{ whiteSpace: "nowrap" }}>{item.name}</td>

                    <td>
                      <div className="city-status-switch">

                        <input
                          type="checkbox"
                          id={`status-${item._id}`}
                          className="city-status-input"
                          checked={item.status === 1}
                          onChange={() =>
                            dispatch(
                              openModal({
                                type: "change-toggle-status",
                                title: "Change Status",
                                data: {
                                  id: item.id,
                                  status: item.status ? "Active" : "Inactive",
                                  statusFunction: ChanegDepartmentstatus,
                                  onSuccess: fetchRoles,
                                },
                              })
                            )
                          }
                        />
                        <label
                          htmlFor={`status-${item._id}`}
                          className="city-status-label"
                        >
                          <span className="city-status-ball"></span>
                          <span className="city-status-text">
                            {item.status === 1 ? "Active" : "Inactive"}
                          </span>
                        </label>
                      </div>
                    </td>
                    <td>{item.status === 1 ? "Active" : "Inactive"}</td>

                    <td className="">
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <button
                          className="st-action-btn st-delete-btn"
                          onClick={() =>
                            dispatch(
                              openModal({
                                type: "view-department",
                                title: "View Department",
                                data: item,
                              })
                            )
                          }
                        >
                          <FaEye />
                        </button>

                        {/* Edit */}
                        <button
                          className="st-action-btn st-view-btn"
                          onClick={() =>
                            dispatch(
                              openModal({
                                type: "edit-department",
                                title: "Edit Department",
                                data: item,
                                refreshData: fetchRoles,
                              })
                            )
                          }
                        >
                          <FaEdit />
                        </button>

                        {/* Delete */}
                        <button
                          className="st-action-btn st-edit-btn"
                          onClick={() =>
                            dispatch(
                              openModal({
                                type: "delete-department",
                                title: "Delete Department",
                                data: {
                                  _id: item.id,
                                  name: item.name,
                                  deleteFunction: DeleteDepartment,
                                  refreshData: fetchRoles,
                                },
                              })
                            )
                          }
                        >
                          <FaTrash />
                        </button>
                      </div>






                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
          {totalPages > 1 && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
     </div>



    </div>
  );
}

export default DeparmentList;